import { memo } from 'react';

import type { MicroFrontendType } from './MicroFrontendTypes';

export const MicroFrontendMemo = memo(
  ({
    Component,
    ...props
  }: {
    Component: ReturnType<MicroFrontendType['component']>;
    [key: string]: any;
  }) => (Component ? <Component {...props} /> : null),
);
